/**
 * The openHASP `tag` an object's pages.jsonl record carried: the single
 * entity of its legacy HASSBuilder rows (`events[]`/`properties[]`), or
 * undefined when they name none or several. Kept apart so ObjectExport can
 * use it without the rest of the Home Assistant modules.
 */
export function legacyHassTag(config) {
    const entities = [
        ...(config?.events || []).flatMap(event => (event.entities || [event.entityId]).filter(Boolean)),
        ...(config?.properties || []).map(property => property.entityId).filter(Boolean),
    ];
    const unique = [...new Set(entities)];
    return unique.length === 1 ? unique[0] : undefined;
}
